import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FILTER_TABS } from './FilterTabBar';

const Strip = styled.div`
   display: flex;
   flex-wrap: wrap;
   justify-content: center;
   gap: 4px;
   margin-top: ${(p) => p.$mt ?? '0px'};
`;
Strip.displayName = 'Strip';

const Chip = styled.span`
   display: inline-flex;
   align-items: center;
   gap: 5px;
   background: #20a8d8;
   border-radius: 20px;
   padding: 4px 12px;
   font-size: 13px;
   color: #fff;
   max-width: 280px;
   white-space: nowrap;
`;
Chip.displayName = 'Chip';

const ChipValue = styled.span`
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
`;
ChipValue.displayName = 'ChipValue';

const RemoveBtn = styled.button`
   background: none;
   border: none;
   padding: 0;
   margin: 0;
   cursor: pointer;
   color: #fff;
   font-size: 12px;
   line-height: 1;
   flex-shrink: 0;
   opacity: 0.75;

   &:hover {
      opacity: 1;
   }

   &:focus {
      outline: none;
   }
`;
RemoveBtn.displayName = 'RemoveBtn';

function FilterChipStrip({ localFilter, onRemove, marginTop }) {
   const activeGroups = FILTER_TABS.filter(({ key }) => localFilter[key] && localFilter[key].length > 0);

   if (activeGroups.length === 0) return null;

   return (
      <Strip $mt={marginTop}>
         {activeGroups.map(({ key, label }) =>
            localFilter[key].map((item) => (
               <Chip key={`${key}-${item.value}`} title={item.label ?? item.value}>
                  <ChipValue>
                     {label}: {item.label ?? item.value}
                  </ChipValue>
                  <RemoveBtn
                     type='button'
                     onClick={() => onRemove(key, item.value)}
                     aria-label={`Remove ${item.value} from ${label} filter`}
                  >
                     &#x2715;
                  </RemoveBtn>
               </Chip>
            )),
         )}
      </Strip>
   );
}

FilterChipStrip.propTypes = {
   localFilter: PropTypes.object.isRequired,
   onRemove: PropTypes.func.isRequired,
   marginTop: PropTypes.string,
};

export default FilterChipStrip;
